module.exports = __webpack_public_path__ + "img/鎏金面膜+珍银面膜_04.0e227de6.jpg";